// @flow
import { PencilSimple, TrashSimple } from "@phosphor-icons/react";
import { Button } from "antd";
import usePermissions from "hooks/usePermissions";
import * as React from "react";
import type { User } from "types/user";
import { buildFullName } from "utils/helpers";

import { useLoadRoles } from "@/queries/profile/roles/useLoadRoles";
import Tooltip from "@/ui/atoms/Tooltip";

import useHover from "../hooks/useHover";
import UI from "../ui";
import { hasText } from "./helpers";

type Props = {
  item: User,
  onEditUser: (User) => void,
  onDeleteUser: (number) => void,
  onSendReminder: (number, string) => void,
};

function TeamTableItem({
  item,
  onEditUser,
  onDeleteUser,
  onSendReminder,
}: Props): React.Node {
  const [hoverRef, hasHover] = useHover();
  const { data: roles } = useLoadRoles();
  const { isAdminUser, canManageTeamUsers } = usePermissions();
  const roleId = item.membership?.permissions_groups[0]?.id;
  const role = roles?.find((role) => role.id === roleId);

  return (
    <tr>
      <UI.TableItem>
        {buildFullName(item.first_name, item.last_name)}
      </UI.TableItem>
      <UI.TableItem>{item.email}</UI.TableItem>
      <UI.TableItem light={hasText(role?.name) === false}>
        {hasText(role?.name) ? role.name : "None"}
      </UI.TableItem>
      <UI.TableItem style={{ maxWidth: 100 }}>
        {item.is_verified ? (
          <span className="py-1 px-2 bg-green-400 text-white rounded">
            Verified
          </span>
        ) : (
          <button
            onClick={() => onSendReminder(item.id, item.email)}
            ref={hoverRef}
          >
            <span className="py-1 px-2 bg-yellow-300 text-txt rounded">
              {hasHover ? "Reinvite" : "Invite sent"}
            </span>
          </button>
        )}
      </UI.TableItem>
      <UI.TableItem className="space-x-4 w-44">
        {role?.is_assignable && (isAdminUser || canManageTeamUsers) && (
          <>
            <Tooltip mouseEnterDelay={0.35} title="Edit">
              <Button
                className="w-[fit-content] !px-4"
                onClick={() => onEditUser(item)}
              >
                <PencilSimple className="text-xl" />
              </Button>
            </Tooltip>
            <Tooltip mouseEnterDelay={0.35} title="Delete">
              <Button
                className="w-[fit-content] !px-4"
                onClick={() => onDeleteUser(item.id)}
              >
                <TrashSimple className="text-xl" />
              </Button>
            </Tooltip>
          </>
        )}
      </UI.TableItem>
    </tr>
  );
}

export default TeamTableItem;
